import React, { useState, useEffect } from "react";
import YouTubeEmbed from "../../YouTube";
import "./index.scss";
import { getLatestVideos, getVideo } from "../../../services";
import { serializeVideoData } from "../../../helpers";
import moment from "moment";

interface VideoItem {
  id: string;
  publishedAt: string;
  title: string;
  viewCount: string;
  thumbnails: thumb;
}

interface Video {
  data: VideoItem;
  setPlayerState?: Function;
  PlayerState?: {
    active: boolean;
  };
}

function fetchData(playlistId: string, isLoaded: Function) {
  const [data, setData] = useState<VideoItem | null>(null);
  useEffect(() => {
    getLatestVideos({ id: playlistId })
      .then(res => serializeVideoData(res.items))
      .then(
        res =>
          new Promise(resolve =>
            getVideo(res[0].id).then(stats => resolve({ res, stats }))
          )
      )
      .then(({ res, stats }) => {
        isLoaded(true);
        setData({ ...stats.items[0].statistics, ...res[0] });
      });
  }, [playlistId]);
  return data;
}

interface thumb {
  standard: {
    url: string;
  };
}

function Video({ data, PlayerState = { active: false } }: Video) {
  const [playVideo, toggleVideo] = useState(false);
  const date = moment(data.publishedAt).fromNow();
  const formattedDate =
    date.indexOf("a ") >= 0 ? date.replace("a ", "1 ") : date;
  const handleOnClick = () => {
    toggleVideo(true);
  };

  const handleVideoEnd = () => {
    toggleVideo(false);
  };

  useEffect(() => {
    toggleVideo(PlayerState.active);
  }, [PlayerState]);

  return typeof data != "undefined" ? (
    <div className={`video ${PlayerState.active ? "video--playing" : "hide"}`}>
      <div className="video-inner video-resize">
        <div />
        {playVideo && !PlayerState.active ? (
          <YouTubeEmbed id={data.id} onEnd={handleVideoEnd} mute={false} />
        ) : null}
        <div className="flex-container">
          <img
            src={
              data.thumbnails && data.thumbnails.standard
                ? data.thumbnails.standard.url
                : ""
            }
            alt={data.title}
          />
          <button
            onClick={handleOnClick}
            className="btn--video-player btn--video-player-large"
          />
        </div>
      </div>
      <div className="video-inner-blurb">
        <p>{data.title}</p>
        <span>
          {formattedDate} - {data.viewCount} views
        </span>
      </div>
    </div>
  ) : (
    <div />
  );
}

function LatestVideos({
  playlistId,
  children = <></>
}: {
  playlistId: string;
  maxResults?: number;
  children?: JSX.Element;
}) {
  let [isLoaded, setIsLoaded] = useState();
  const data = fetchData(playlistId, setIsLoaded);
  const [PlayerState, setPlayerState] = useState({ active: false });
  const mainVideoState = { PlayerState, setPlayerState };

  const clonedChildren = React.Children.map(
    children,
    (child: React.ReactElement) => {
      return React.cloneElement(child, { ...mainVideoState });
    }
  );

  return (
    <div className={`latest-videos ${!isLoaded ? " isLoading" : ""}`}>
      <div className="grid-container">
        {data ? <Video {...mainVideoState} data={data} /> : null}
        {clonedChildren}
      </div>
    </div>
  );
}

export default LatestVideos;
